import React, { useEffect, useState } from 'react';
import { AvatarGroup, Avatar, Box } from '@mui/material';
import theme from '../../theme';

const MemberDisplay = ({ members = [], maxVisible = 3 }) => {
  const [imageUrls, setImageUrls] = useState([]);
  const loadImageAsBlob = async (avatarPath, userId) => {
    try {
      const fullUrl = `${process.env.REACT_APP_BASE_URL}/file?bname=${avatarPath}&download=false`;
      const response = await fetch(fullUrl, {
        headers: {
          'Authorization': `Bearer ${localStorage.getItem('token')}`
        }
      });

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const blob = await response.blob();
      const objectUrl = URL.createObjectURL(blob);

      setImageUrls(prev => ({
        ...prev,
        [userId]: objectUrl
      }));
    } catch (error) {
      console.error('Error loading image:', error);
    }
  };

  // Load all images when mentors are set
  useEffect(() => {
    if (members?.length > 0) {
      members?.map(mentor => {
        if (mentor.user?.avatar && !imageUrls[mentor.user_name]) {
          loadImageAsBlob(mentor.user.avatar, mentor.user_name);
        }
      });
    }
  }, [members]);

  useEffect(() => {
    return () => {
      Object.values(imageUrls)?.forEach(url => {
        if (url) URL.revokeObjectURL(url);
      });
    };
  }, []);

  return (
    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
      <AvatarGroup
        max={maxVisible}
        sx={{
          '& .MuiAvatar-root': {
            width: 35,
            height: 35,
            fontSize: '0.8rem',
            border: '1px solid white',
            background: theme.palette.background.dark,
            fontWeight: 600
          }
        }}
      >
        {members.map((member, index) => (
          <Avatar
            key={index}
            alt={member?.user_name || `Member ${index + 1}`}
            src={imageUrls[member?.user_name]}
          >
            {member?.user_name?.charAt(0)?.toUpperCase()}
          </Avatar>
        ))}
      </AvatarGroup>
    </Box>
  );
};

export default MemberDisplay;